module.exports = __webpack_public_path__ + "img/logo_wide_apr.c74f349e.svg";